// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i0aW3{margin-top:8px}.NoG9E{margin-top:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"followUp": `i0aW3`,
	"suggestionChips": `NoG9E`
};
export default ___CSS_LOADER_EXPORT___;
